import React, { Component } from 'react';
import './RCFGraphs.css';
import { t } from 'i18next';

import LineGraph from '../LineGraph/LineGraph';

class RCFGraphs extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    const { data } = this.props;
    this.formatData(data);
  }

  componentWillReceiveProps(props) {
    const { data } = props;
    this.formatData(data);
  }

  formatData(data) {
    if (data.length !== 1) {
      const rawData = [];
      const transformData = [];
      const resultData = [];
      data.forEach((value, i) => {
        const xValue = new Date(value['x-axis']);
        rawData[i] = {
          x: xValue,
          y: parseFloat(value.raw, 10),
        };
        transformData[i] = {
          x: xValue,
          y: parseFloat((value.transform ? value.transform : 0), 10),
        };
        resultData[i] = {
          x: xValue,
          y: parseFloat((value.result ? value.result : 0), 10),
        };
      });
      this.setState({
        rawData,
        resultData,
        transformData,
      });
    }
  }

  render() {
    const {
      rawData, transformData, resultData,
    } = this.state;
    const { propertyText = 'Property', yAxisLabel, } = this.props;
    return (
      <div className="board">
        {resultData && (
          <div className="graph-row">
            <div className="graph-row-content deviation">
              <div className="graph-row-title">
                {`${propertyText} ${t('tensorAnalytics.graphs.randomCutForest.resultTitle')}`}
              </div>
              <LineGraph data={resultData}
                textLine={t('tensorAnalytics.graphs.result')}
                yAxisTitle={yAxisLabel || `${propertyText} ${t('tensorAnalytics.graphs.resultyAxis')}`}
                colorLine="#AAC5EA"
              />
            </div>
          </div>
        )}
        {rawData && (
          <div className="graph-row">
            <div className="graph-row-content raw">
              <div className="graph-row-title">
                {`${propertyText} ${t('tensorAnalytics.graphs.rawTitle')}`}
              </div>
              <LineGraph data={rawData}
                textLine={t('tensorAnalytics.graphs.raw')}
                yAxisTitle={`${propertyText} ${t('tensorAnalytics.graphs.rawValue')}`}
                colorLine="#0074B7"
                xAt0
              />
            </div>
          </div>
        )}
        {transformData && (
          <div className="graph-row">
            <div className="graph-row-content">
              <div className="graph-row-title">
                {`${propertyText} ${t('tensorAnalytics.graphs.transformData')}`}
              </div>
              <LineGraph data={transformData}
                textLine={t('tensorAnalytics.graphs.transformData')}
                yAxisTitle={`${propertyText} ${t('tensorAnalytics.graphs.transformyAxis')}`}
                colorLine="#60922D"
              />
              <div className="subText">
                <em>
                  {`*Normalized values transform the data with a scaling factor to make the model less
                  prone to extreme values`}
                </em>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default RCFGraphs;
